export default "__VITE_ASSET__BMGIPjqd__"